import { render, staticRenderFns } from "./MCompanyEditorFieldset.yaml?vue&type=template&id=f06a77b4&component"
import script from "./MCompanyEditorFieldset.yaml?vue&type=script&lang=ts&component"
export * from "./MCompanyEditorFieldset.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports